import React from "react"
import tw from "twin.macro"

import { withFooterSocialLinks } from "./withFooterSocialLinks"
// import { StyledButton } from "../Styled/Button"
import { Icon } from "../Icon/Icon"
// import facebook from "../../../static/images/facebook.png"
// import insta from "../../../static/images/insta.png"
import { useWindowSize } from "../../hooks/useWindowSize"

const ButtonGroup = tw.div`flex mt-1 md:mt-2`
// const Button = tw(StyledButton)`mr-1 bg-light`
// const Img = tw.img`w-full`
const StyledIcon = tw(Icon)`cursor-pointer mr-1 md:mr-1-4`

const FooterSocialLinks = withFooterSocialLinks(({ items, onClickButton }) => {
  const {
    windowSize: { isMobile },
  } = useWindowSize()
  // const iconSize = isMobile ? "32px" : "38px"
  const iconSize = isMobile ? "30px" : "40px"

  return (
    <ButtonGroup>
      {items?.map(
        (item, index) =>
          // <Button className={`circle-button`} key={index} layout={`circle`} onClick={() => onClickButton(item)} textsize={`sm`}>
          //   {item?.title}
          // </Button>
          // <Button key={index} onClick={() => onClickButton(item)} textsize={`sm`} style={{ width: iconSize, height: iconSize }}>
          //   {item && item.title === "IG" ? <Img src={insta} alt="" /> : <Img src={facebook} alt="" />}
          // </Button>
          // item && item.title === "IG" ? (
          //   <StyledIcon name={`insta`} size={iconSize} onClick={() => onClickButton(item)} />
          // ) : (
          //   <StyledIcon name={`fb`} size={iconSize} onClick={() => onClickButton(item)} />
          // )
          item && <StyledIcon key={index} name={item.title === "IG" ? `insta` : `fb`} size={iconSize} onClick={() => onClickButton(item)} />
      )}
    </ButtonGroup>
  )
})

export default FooterSocialLinks
